import React from "react";
import { Box, Button, Heading, Text, Alert, AlertIcon, HStack, Badge } from "@chakra-ui/react";
import FacilitySection from "./sections/FacilitySection";
import PrimaryContactSection from "./sections/PrimaryContactSection";
import PhysicianSection from "./sections/PhysicianSection";
import AdditionalPhysiciansSection from "./sections/AdditionalPhysiciansSection";
import ShippingSection from "./sections/ShippingSection";
import SalesSection from "./sections/SalesSection";

const BAAForm = ({
  handleNext,
  updateError,
  isFormComplete,
  updatedFields,
  originalData,
  isSubmitting,
  ...formProps
}) => {
  return (
    <Box maxW="800px" mx="auto" p={6} textAlign="center" className="content-container">
      <Heading as="h1" mb={4}>Practice Information Updater</Heading>
      <Text fontSize="lg" mb={4} color="gray.600">
        Update the Facility Information, Physician Details, Contact Information, and Shipping Addresses.
      </Text>

      {/* Legend for color-coded sections */}
      <HStack justifyContent="center" spacing={4} mb={6}>
        <Badge colorScheme="blue" px={4} py={2} borderRadius="md">
          Blue: Edited Sections
        </Badge>
        <Badge colorScheme="green" px={4} py={2} borderRadius="md">
          Green: Added Sections
        </Badge>
        <Badge colorScheme="red" px={4} py={2} borderRadius="md">
          Red: Deleted Sections
        </Badge>
      </HStack>

      {updateError && (
        <Alert status="error" mt={4}>
          <AlertIcon />
          {updateError}
        </Alert>
      )}

      <FacilitySection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />
      <PrimaryContactSection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />
      <PhysicianSection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />
      <AdditionalPhysiciansSection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />
      <ShippingSection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />
      <SalesSection
        {...formProps}
        updatedFields={updatedFields}
        originalData={originalData}
      />

      <Button
        mt={6}
        colorScheme="green"
        onClick={handleNext}
        isDisabled={!isFormComplete}
        isLoading={isSubmitting}
      >
        Save
      </Button>
    </Box>
  );
};

export default BAAForm;